import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M21 3H3v18h18V3zm-4 10H7v-2h10v2z"
}), 'IndeterminateCheckBoxSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/IndeterminateCheckBoxSharp.js
// module id = 4243
// module chunks = 2